import React, { useContext } from 'react';
import { FilterContext } from '../../context/Filter';

const Sparecardtb = (props) => {
    const { open } = useContext(FilterContext); // true = sidebar open

    return (
        <div
            className={`ml-1 w-[400px] md:w-full   rounded-md mt-1 
                `} // Dynamically change width
        >
            <div className="bg-[#2374BF] text-white  py-1  rounded-t-lg text-center font-semibold text-sm">
                {props.heading}
            </div>

            {props.vcards}
            {props.des}
        </div>
    );
};

export default Sparecardtb;
